// material-ui

import printoutsourceconfirmationicon from '../../../assets/images/card-resources.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const PrintOutsourceConfirmationIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={printoutsourceconfirmationicon} alt="Print Outsource Confirmation" width="22"  />
    );
};

export default PrintOutsourceConfirmationIcon;
